<template>
    <div
        class="lp-assignment-card"
        @click="openModal">
        <div class="header">
            <img
                class="banner"
                :src="lpAssignmentIn.file.path"
                :alt="lpAssignmentIn.name + 'banner'" />
            <div class="title-wrapper">
                <h4 class="title">{{ lpAssignmentIn.name }}</h4>
            </div>
        </div>
        <div class="body">
            <div class="short-description">
                <design-2021-apprentice-display-html-component
                    :html-content="lpAssignmentIn.description | editor_text_preview(25)">
                </design-2021-apprentice-display-html-component>
            </div>
            <div class="read-more btn-after-long-arrow-icon">
                {{ $t('learning_path.more_information') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-learning-path-assignment-card-component',
    props: ['lpAssignmentIn'],
    methods: {
        lpAssignmentLink() {
            return '#';
            //return this.routes.lpAssignment(this.lpAssignmentIn.id)
        },
        openModal() {
            this.$emit('open-modal', this.lpAssignmentIn);
        },
    },
};
</script>

<style scoped lang="scss">
.lp-assignment-card {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    margin-bottom: $grid-gutter-width;
    border-radius: 12px;

    &:hover {
        box-shadow:
            0 3px 21px 0 rgba($black, 10%),
            0 1px 8px 0 rgba($black, 5%);
        cursor: pointer;

        .header {
            img {
                filter: grayscale(0.5);
            }
        }
    }
}

.header {
    position: relative;

    img {
        height: 150px;
        width: 100%;
        object-fit: cover;
        object-position: center;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
    }

    .title-wrapper {
        position: absolute;
        bottom: 0;
        background-color: rgba($primary-background-color, 0.54);
        padding: map-get($grid-gutter-spacing, 'ten') map-get($grid-gutter-spacing, 'fifteen');
        width: 100%;

        .title {
            color: $white;
            margin: 0;
        }
    }
}

.body {
    display: flex;
    flex-direction: column;
    background-color: $white;
    font-size: $default-font-size;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    height: 100%;

    .short-description {
        padding: map-get($grid-gutter-spacing, 'fifteen');
        margin-bottom: $grid-gutter-width;
    }
}

.read-more {
    justify-content: flex-end;
    font-weight: $font-weight-medium;
    margin-top: auto;
    font-size: $base-font-size;
    color: $primary;
    padding-right: map-get($grid-gutter-spacing, 'fifteen');
    padding-bottom: map-get($grid-gutter-spacing, 'fifteen');

    &:after {
        font-size: $base-font-size;
    }
}
</style>
